module.exports = __webpack_public_path__ + "static/media/Impreza-GE-GH-Sti.f781e374.jpg";